import React from 'react';
import { IconChevronLeft, IconChevronRight } from '../Icons';
import { jumpToYear, shiftMonth } from './tradeCalendar';

const MONTH_OPTIONS = Array.from({ length: 12 }, (_, index) => {
  const value = String(index + 1).padStart(2, '0');
  const label = new Date(2000, index, 1).toLocaleDateString('en-US', { month: 'long' });
  return { value, label };
});

export default function TradeMonthNavigator({
  monthKey = null,
  onMonthKeyChange = null,
  monthsWithData = [],
  yearsWithData = [],
  showLatest = true,
  className = '',
}) {
  if (!onMonthKeyChange) return null;

  const year = monthKey ? monthKey.slice(0, 4) : '';
  const month = monthKey ? monthKey.slice(5, 7) : '';
  const years = yearsWithData.length
    ? yearsWithData
    : (year ? [year] : [String(new Date().getFullYear())]);
  const latestMonth = monthsWithData[0] || null;

  const setMonthKey = (next) => {
    const value = typeof next === 'function' ? next(monthKey) : next;
    if (value) onMonthKeyChange(value);
  };

  const yearOptions = (year && !years.includes(year) ? [year, ...years] : years);

  return (
    <div className={`vd-cal-nav${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        className="vd-cal-nav-btn"
        onClick={() => setMonthKey((current) => shiftMonth(current, -1))}
        aria-label="Previous month"
        disabled={!monthKey}
      >
        <IconChevronLeft size={16} />
      </button>

      <select
        className="vd-cal-month-select"
        value={month}
        onChange={(e) => {
          const nextYear = year || years[0] || String(new Date().getFullYear());
          setMonthKey(`${nextYear}-${e.target.value}`);
        }}
        aria-label="Select month"
        disabled={!monthKey}
      >
        {MONTH_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>

      <select
        className="vd-cal-year"
        value={year}
        onChange={(e) => setMonthKey((current) => jumpToYear(current, e.target.value, monthsWithData))}
        aria-label="Select year"
        disabled={!monthKey}
      >
        {yearOptions.map((optionYear) => (
          <option key={optionYear} value={optionYear}>{optionYear}</option>
        ))}
      </select>

      <button
        type="button"
        className="vd-cal-nav-btn"
        onClick={() => setMonthKey((current) => shiftMonth(current, 1))}
        aria-label="Next month"
        disabled={!monthKey}
      >
        <IconChevronRight size={16} />
      </button>

      {showLatest && latestMonth ? (
        <button
          type="button"
          className="vd-cal-latest"
          onClick={() => setMonthKey(latestMonth)}
          disabled={monthKey === latestMonth}
        >
          Latest
        </button>
      ) : null}
    </div>
  );
}
